'use client';
import React, { useEffect } from 'react';
import { ProductComparisonGrid } from '@cat-ecom/pcc-components';
import { BuyAgainCarouselProps } from '../types';
import { ProductCardCarouselWrapper } from '../../../product-card/product-card-carousel/product-card-carousel-wrapper';
import { useGaEventContext } from '../../gaevent-context-provider';
import useProductCardsGAEvent from '../../../../hooks/use-product-card-ga-events/use-product-card-ga-events';
import styles from '../buy-again.module.scss';

export const BuyAgainCarousel = ({
  children,
  showCarousel,
  products,
  cartDetails
}: Readonly<BuyAgainCarouselProps>) => {
  const { isGAEventEnabled, handleClickGaEvent } = useProductCardsGAEvent({
    products,
    cartDetails,
    listNameId: 'PCC HP BUY Again',
    activeTab: 'buyAgain'
  });
  const { handleGaEventCapture } = useGaEventContext();

  useEffect(() => {
    if (isGAEventEnabled) {
      handleClickGaEvent();
      handleGaEventCapture('buyAgain', false);
    }
  }, [isGAEventEnabled, handleClickGaEvent, handleGaEventCapture]);

  return (
    <>
      {showCarousel ? (
        <ProductCardCarouselWrapper
          gridClassName={styles['buy-again-grid-wrapper']}
        >
          {children}
        </ProductCardCarouselWrapper>
      ) : (
        <ProductComparisonGrid classname={styles['buy-again-grid-scroll']}>
          {children}
        </ProductComparisonGrid>
      )}
    </>
  );
};
